/**
 * @format
 */

import React from 'react';
import WeeklyPremiumChart from '../components/WeeklyPremiumChart';
import { DashboardQueryParams } from '../types/dashboard.types';

interface WeeklyPremiumContainerProps {
  params?: DashboardQueryParams;
}

const WeeklyPremiumContainer: React.FC<WeeklyPremiumContainerProps> = ({ params }) => {
  return <WeeklyPremiumChart params={params} />;
};

export default WeeklyPremiumContainer;
